import { modelStrategyEndpoints as endpoints } from '@/api/endpoints';
import { callDelete, callGet, callPatch } from '@/api/fetcher';
import { ModelCatalog, ModelStrategy } from '@/shared/types/modelStrategy';

export const modelStrategyApi = Object.freeze({
  get: (brainId: string): Promise<ModelStrategy> => callGet(endpoints.strategy(brainId)),

  /** Replace the full strategy atomically. Returns the persisted shape. */
  patch: (brainId: string, body: ModelStrategy): Promise<ModelStrategy> =>
    callPatch(endpoints.strategy(brainId), body),

  /** Clear all strategy rows for the brain. */
  remove: (brainId: string): Promise<void> => callDelete(endpoints.strategy(brainId)),

  catalog: (brainId: string): Promise<ModelCatalog> => callGet(endpoints.catalog(brainId)),
});
